// extracted by mini-css-extract-plugin
module.exports = {"popup":"c6e8ba5398--popup--2AM6E"};